import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-neutral border-t mt-auto">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Info */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img src="/Logo_puglialife.webp" alt="Puglia Life - Home Care" className="h-20 w-auto object-contain" />
            </Link>
            <p className="text-sm text-text-body max-w-xs">
              Assistenza domiciliare personalizzata e professionale. 
              Ci prendiamo cura del tuo benessere respiratorio e nutrizionale.
            </p>
          </div>

          {/* Servizi */}
          <div>
            <h3 className="font-heading font-bold text-text-title mb-4">Servizi</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/servizi/ossigenoterapia" className="text-text-body hover:text-brand-primary transition-colors">
                  Ossigenoterapia
                </Link>
              </li>
              <li>
                <Link to="/servizi/ventiloterapia" className="text-text-body hover:text-brand-primary transition-colors">
                  Ventiloterapia
                </Link>
              </li>
              <li>
                <Link to="/servizi/sonno" className="text-text-body hover:text-brand-primary transition-colors">
                  Disturbi del Sonno
                </Link>
              </li>
              <li>
                <Link to="/servizi/nutrizione" className="text-text-body hover:text-brand-primary transition-colors">
                  Nutrizione Clinica
                </Link>
              </li>
            </ul>
          </div>

          {/* Link Utili */}
          <div>
            <h3 className="font-heading font-bold text-text-title mb-4">Puglia Life</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/chi-siamo" className="text-text-body hover:text-brand-primary transition-colors">
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link to="/risorse" className="text-text-body hover:text-brand-primary transition-colors">
                  Risorse & Guide
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-text-body hover:text-brand-primary transition-colors">
                  Contatti
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-text-body hover:text-brand-primary transition-colors font-medium">
                  Area Riservata
                </Link>
              </li>
              <li>
                <Link to="/area-commerciale" className="text-text-body hover:text-brand-primary transition-colors font-medium">
                  Area Commerciale
                </Link>
              </li>
            </ul>
          </div>

          {/* Compliance */}
          <div>
            <h3 className="font-heading font-bold text-text-title mb-4">Compliance</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-text-body hover:text-brand-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie" className="text-text-body hover:text-brand-primary transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/note-legali" className="text-text-body hover:text-brand-primary transition-colors">
                  Note Legali
                </Link>
              </li>
              <li>
                <Link to="/dichiarazione-accessibilita" className="text-text-body hover:text-brand-primary transition-colors">
                  Dichiarazione di Accessibilità
                </Link>
              </li>
              <li>
                <Link to="/politica-aziendale" className="text-text-body hover:text-brand-primary transition-colors">
                  Politica Aziendale
                </Link>
              </li>
              <li>
                <Link to="/parita-di-genere" className="text-text-body hover:text-brand-primary transition-colors">
                  Parità di Genere
                </Link>
              </li>
              <li>
                <Link to="/whistleblowing" className="text-text-body hover:text-brand-primary transition-colors">
                  Whistleblowing
                </Link>
              </li>
              <li>
                <Link to="/farmacovigilanza" className="text-text-body hover:text-brand-primary transition-colors">
                  Farmacovigilanza
                </Link>
              </li>
              <li>
                <Link to="/mog" className="text-text-body hover:text-brand-primary transition-colors">
                  MOG 231
                </Link>
              </li>
              <li>
                <Link to="/codice-etico" className="text-text-body hover:text-brand-primary transition-colors">
                  Codice Etico
                </Link>
              </li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h3 className="font-heading font-bold text-text-title mb-4">Contatti</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-brand-primary shrink-0" />
                <span className="text-text-body">
                  Sedi a Bari, Taranto e Mesagne
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-brand-primary shrink-0" />
                <div className="flex flex-col gap-1">
                  <a href="tel:800290361" className="text-text-body font-bold hover:text-brand-primary">
                    Numero Verde: 800 290 361
                  </a>
                  <a href="tel:+390805378955" className="text-text-body hover:text-brand-primary">
                    +39 080 537 8955
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-brand-primary shrink-0" />
                <a href="mailto:info@puglialifesrl.it" className="text-text-body hover:text-brand-primary">
                  info@puglialifesrl.it
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 text-center text-sm text-text-body">
          <p>&copy; {currentYear} Puglia Life SRL. Tutti i diritti riservati. P.IVA 05419220727</p>
          <div className="mt-4 flex justify-center items-center space-x-4">
            <Link to="/dichiarazione-accessibilita" className="hover:text-brand-primary font-medium transition-colors">
              Dichiarazione di Accessibilità
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
